import PoiFieldsAdder from './PoiFieldsAdder';
import { Box } from '@mui/material';

type Props = {
  mode: 'ReadOnly' | 'Edit';
  allowedTemplateKeys: string[];
  existingKeys: string[];
  onAddColumn: (field: { key: string; displayName?: string | null }) => void;
};

export const NominationFieldsEditor = ({
  mode,
  allowedTemplateKeys,
  existingKeys,
  onAddColumn,
}: Props) => {
  return (
    <>
      <Box sx={{ mt: 0 }}>
        <PoiFieldsAdder
          allowedTemplateKeys={allowedTemplateKeys}
          mode={mode}
          onAdd={(key: string, name: string) => onAddColumn({ key, displayName: name })}
          existingKeys={existingKeys}
        />
      </Box>
    </>
  );
};
